// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import adminMenu from '../../../../../menu-items/index';
import instituitionMenu from '../../../../../menu-items/users';
import ngoMenu from '../../../../../menu-items/page';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const mainUser = JSON.parse(sessionStorage.getItem("main-user"));
  const role = mainUser?.roleId?.name || mainUser?.user?.roleId?.name;
  const menuConfig = role === 'Institution' ? instituitionMenu : role === "Admin" ? adminMenu : ngoMenu;
  const navGroups = menuConfig.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
